export default "__VITE_ASSET__$1r57X8Q__"